import { render, staticRenderFns } from "./editTg.vue?vue&type=template&id=49c13b6a&scoped=true"
import script from "./editTg.vue?vue&type=script&lang=js"
export * from "./editTg.vue?vue&type=script&lang=js"
import style0 from "./editTg.vue?vue&type=style&index=0&id=49c13b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c13b6a",
  null
  
)

export default component.exports